<div class="container py-3">
  <app-dynamic-section-form
    #sectionForm
    [schema]="schema"
    [modelToPatchToForm]="existingRecord"
    [entityId]="entityId"
    (onChange)="handleFieldChange($event)"
    (enterPressed)="onSubmit(sectionForm)"
  >
  </app-dynamic-section-form>

  <div class="d-flex justify-content-end gap-2 mt-3">
    <button type="button" class="btn btn-outline-secondary" (click)="sectionForm.form.reset()">
      Reset
    </button>
    <button type="button" class="btn btn-primary" (click)="onSubmit(sectionForm)">
      Submit
    </button>
  </div>
</div>
